import { useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '~/store/types';
import { selectNotifications } from './ducks';
import Notifications from './notifications';
import { hideQueuedNotification } from './ducks/actions';
import { Notification } from './ducks/types';

const NotificationsQueueContainer = () => {
	const notifications = useAppSelector(selectNotifications);
	const dispatch = useAppDispatch();

	const actions = useMemo(
		() => ({ hideNotification: (id: string) => dispatch(hideQueuedNotification(id)) }),
		[dispatch]
	);

	// Filter out undefined notifications
	const validNotifications: Notification[] = Array.isArray(notifications)
		? notifications.filter((n): n is Notification => n !== undefined && n !== null)
		: [];

	// Filter out duplicate notifications by id
	const uniqueNotifications = validNotifications.filter(
		(notification, index, self) => index === self.findIndex(n => n.id === notification.id)
	);

	return uniqueNotifications.slice(0, 3).map(notification => (
		// @ts-expect-error check necessary props after migration Notifications to typescript
		<Notifications key={notification.id} actions={actions} {...notification} />
	));
};

export default NotificationsQueueContainer;
